import { useState } from 'react';
import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

import AuthForm from '@/components/authForm/AuthForm';
import Loader from '@/components/Loader';
import { GiftHook } from '@/hooks/purchase';
import { useAppLoadedState, useUserState } from '@/hooks/store';

import RedeemForm from './RedeemForm';
import RedeemSuccess from './RedeemSuccess';

const RedeemContainer = styled.div`
	box-sizing: border-box;
	max-width: 464px;
	width: 90%;

	${minWidth('desktop')} {
		max-width: none;
		padding: 0 1rem 0 4.88rem;
		width: 100%;
	}
`;

const LeftContainer = styled.div`
	box-sizing: border-box;
	color: ${palette('black')};
	line-height: 1.5;
`;

interface RedeemFlowProps {
	gift: GiftHook;
}

const RedeemFlow = ({ gift }: RedeemFlowProps) => {
	const user = useUserState();
	const appLoaded = useAppLoadedState();
	const [isLifetime, setIsLifetime] = useState(false);

	if (!user?.token) {
		return appLoaded ? (
			<RedeemContainer>
				<AuthForm />
			</RedeemContainer>
		) : (
			<Loader color="gray7" />
		);
	}

	if (!gift.hasRedeemed) {
		return (
			<RedeemContainer>
				<RedeemForm gift={gift} setIsLifetime={setIsLifetime} />
			</RedeemContainer>
		);
	}

	return (
		<LeftContainer>
			<RedeemSuccess isLifetime={isLifetime} />
		</LeftContainer>
	);
};

export default RedeemFlow;
